import Attributes from "../Attributes.js";
/**
 * Given an array of attribute names or objects with a 'name'
 * key that is an attribute name, return a map of attrName to value
 * for the objRef. If an attribute doesnt exist or is undefined, it
 * will not be represented in the returned map
 */
function toValues(attributes, objRef, active, cxt) {
  const vals = {};
  attributes?.forEach(attr => {
    let attrName;
    if (typeof attr === 'string') {
      attrName = attr;
    } else if (attr?.name) {
      attrName = attr.name;
    }
    if (attrName) {
      const v = Attributes.get(attrName, objRef, cxt);
      if (v !== undefined) {
        vals[attrName] = v;
      }
    }
  });
  return vals;
}

/**
 * Returns a setter transaction object with a run() method that returns
 * a Promise. If run is invoked, this will attempt to set the values
 * on the objRef. 
 * @param objRef {object} the object to set data on
 * @param values {object} the attribute names to values Map
 * @param active {object} the attribute names to use map. If this is null
 * all attributes will be used. To prevent an attribute from being used, the
 * value in this object should be false.
 * @param cxt {object} the context
 * @returns null if no setters were created, or the transaction to run
 */
function toTransaction(objRef, values, active, cxt, tx) {
  let transaction = tx == null ? true : tx;
  Object.entries(values).forEach(([key, val]) => {
    transaction = Attributes.set(key, objRef, val, cxt, transaction);
  });
  return transaction === true ? null : transaction;
}
function createDataChange(evt, value) {
  const changes = {};
  if (typeof evt.data === 'string') {
    changes[evt.data] = evt.value;
  } else if (evt.data && typeof evt.data === 'object' && !Array.isArray(evt.data)) {
    const keys = Object.keys(evt.data);
    keys.forEach(key => {
      const p = evt.data[key];
      if (typeof p === 'string') {
        changes[key] = evt.value[p];
      } else if (typeof p === 'function') {
        changes[key] = p(evt.value);
      }
    });
  }
  return {
    value: {
      ...value,
      ...changes
    },
    changes
  };
}
export default {
  toValues,
  toTransaction,
  createDataChange
};